import UpdateVariableModel from '../models/UpdateVariableModel';
import Axios from 'axios';



export default class UpdateVariableService
{
    constructor() { }

    async update(data: UpdateVariableModel) {
        let res = await Axios.post('/api/updatevariable/update', data);
        return res.data;
    }
}